import BaseCommunication from "../../Communication/BaseCommunication";
import store from "../../Redux/store";
import {
	API_URL,
	API_BASE_URL,
	HttpMethod,
	OperationStatus,
} from "../../Communication/Constants";
import { GET_SUBSCRIPTION_TRANSACTION_HISTORY, CREATE_TRANSACTION_V2, GET_USER_MAPPING_LIST, GET_PRODUCT_PLAN_INFO, SUBSCRIPTION_PAY, UNSUBSCRIBE_SUBSCRIPTION, GET_PAYMENT_METHODS } from "./Constants";

export default class PlansAction extends BaseCommunication {
    
	getTransactionHistory(callback) {
		this.callAPI(GET_SUBSCRIPTION_TRANSACTION_HISTORY, API_BASE_URL + API_URL.v2 + API_URL.TRANSACTION_HISTORY, HttpMethod.GET, {},
			(apiResponse) => {
				if (apiResponse.status === OperationStatus.SUCCESS) {
					if (apiResponse.data !== null) {
						store.dispatch({
							type: GET_SUBSCRIPTION_TRANSACTION_HISTORY,
							response: apiResponse.data.data,
						});
					}
				}
				callback(apiResponse);
			}
		);
	}
    createTransactionV2(request, callback) {
		const requestBody = {
			device_type : request.device_type,
			upgrades_list : request.upgrades_list,
			country_code : request.country_code,
		}
        this.callAPI(CREATE_TRANSACTION_V2, API_BASE_URL + API_URL.v2 + API_URL.PLAN_TRANSACTION, HttpMethod.POST, requestBody,
             (apiResponse) => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
					if (apiResponse.data !== null) {
						store.dispatch({
							type: CREATE_TRANSACTION_V2,
							response: apiResponse.data.data,
						});
					}
				}
				callback(apiResponse);
             });
    }

	getProductPlanInfo(callback) {
		this.callAPI(GET_PRODUCT_PLAN_INFO, API_BASE_URL + API_URL.GET_PROUDUCT_PLAN, HttpMethod.GET, {},
			(apiResponse) => {
				if (apiResponse.status === OperationStatus.SUCCESS) {
					if(apiResponse.data !== null) {
						store.dispatch({
							type: GET_PRODUCT_PLAN_INFO,
							response: apiResponse.data.data
						});
					}
				}
				callback(apiResponse);
			});
	}
	getUserMappingList(requestData, callback) {
        this.callAPI(GET_USER_MAPPING_LIST, API_BASE_URL + API_URL.BASE_USER_URL + requestData.userId + API_URL.USER_MONITOR_MAPPING, HttpMethod.GET, {},
            (apiResponse) => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
                    if (apiResponse.data !== null) {
                        store.dispatch({
                            type: GET_USER_MAPPING_LIST,
                            response: apiResponse.data.data,
                        });
                    }
                }
                callback(apiResponse);
            }
        );
    }

	subscriptionPay (requestData, callback) {

		let requestObject = {
			transaction_id: requestData.transactionId,
			plan_id: requestData.planId,
			cardNo: requestData.cardNo,
			expiryMonth: requestData.expiryMonth,
			expiryYear: requestData.expiryYear,
			cvv: requestData.cvv,
			name: requestData.name,
			email: requestData.email,
			payment_method: ""
		}

		if (requestData.paymentMethodId && requestData.paymentMethodId.trim().length > 0) {
			requestObject.payment_method = requestData.paymentMethodId;
		} 
		else if (requestData.cardNo) {
		
			let cardObject = {
				number: requestData.cardNo,
				expiry: {
					month: requestData.expiryMonth,
					year: requestData.expiryYear
				},
				cvv: requestData.cvv,
				name:requestData.name,
				email: requestData.email,
				isDefault: true
			}

			let card = {
				card: cardObject
			}

			requestObject.payment_method = card;
		}


		this.callAPI(SUBSCRIPTION_PAY, API_BASE_URL + API_URL.v2 + API_URL.SUBSCRIPTION_PAY, HttpMethod.POST, requestObject,
			(apiResponse) => {
				if(apiResponse.status === OperationStatus.SUCCESS){
					if(apiResponse.data !== null){
						store.dispatch({
							type: SUBSCRIPTION_PAY,
							response: apiResponse.data.data
						});
					}
				}
				callback(apiResponse)
			});
	}

	unsubscribe (subscriptionId, callback) {
		this.callAPI(UNSUBSCRIBE_SUBSCRIPTION, API_BASE_URL + API_URL.UNSUBSCRIBE + subscriptionId, HttpMethod.POST, {},
			(apiResponse) => {
				if(apiResponse.status === OperationStatus.SUCCESS) {
					if ( apiResponse.data !== null) {
						store.dispatch({
							type: UNSUBSCRIBE_SUBSCRIPTION,
							response: apiResponse.data.data
						});
					}
				}
                callback(apiResponse);
			});
	}

	getPaymentMethods (userId, callback) {
		this.callAPI(GET_PAYMENT_METHODS, API_BASE_URL + API_URL.GET_PAYMENT_METHODS + userId, HttpMethod.GET, {},
			(apiResponse) => {
				if(apiResponse.status === OperationStatus.SUCCESS) {
					if ( apiResponse.data !== null) {
						store.dispatch({
							type: GET_PAYMENT_METHODS,
							response: apiResponse.data.data
						});
					}
				}
                callback(apiResponse);
			});
	}
}
